module.exports = __webpack_public_path__ + "img/book4.8544b7d3.png";